import Cookies from 'js-cookie';

// User
const tokenKey = process.env.VUE_APP_ENV + '_ncu_physical_examination_access_token';
export const getToken = () => Cookies.get(tokenKey);
export const setToken = (token: string) => Cookies.set(tokenKey, token);
export const removeToken = () => Cookies.remove(tokenKey);

// ScrollTop
const scrollTopKey = process.env.VUE_APP_ENV + '_ncu_physical_examination_access_scrollTop';
export const getScrollTop = () => Number(Cookies.get(scrollTopKey));
export const setScrollTop = (scrollTop: string) => Cookies.set(scrollTopKey, scrollTop);
export const removeScrollTop = () => Cookies.remove(scrollTopKey);
